import {
  BadgePlus,
  CalendarPlus,
  FilePlus2,
  ListPlus,
  UserPlus,
} from 'lucide-react'

import { CommandProps } from '~/components/command-menu/types'
import { NewOrgModal } from '~/components/settings/NewOrgModal'
import { sendTrackingData } from '~/utils/tracking'

export const createCommands: CommandProps[] = [
  {
    category: 'create',
    label: () => 'Create contact',
    icon: () => <UserPlus />,
    value: () => 'Create - New - Contact',
    onSelect: ({ actions: { navigate, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'create',
        item: 'new_contact',
      })

      navigate('/contacts/new')
      setActiveView(null)
    },
    shortcuts: ['c > c'],
    restrictModifiers: true,
  },
  {
    category: 'create',
    label: () => 'Create invoice',
    icon: () => <FilePlus2 />,
    value: () => 'Create - New - Invoice',
    onSelect: ({ actions: { setActiveView, navigate } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'create',
        item: 'new_invoice',
      })

      navigate('/invoices/create')

      setActiveView(null)
    },
    isDisabled: ({ orgMember, pathname }) =>
      orgMember?.role !== 'OWNER' || pathname === '/invoices/create/',
    shortcuts: ['c > i'],
  },
  {
    category: 'create',
    label: () => 'Create schedule',
    icon: () => <CalendarPlus />,
    value: () => 'Create - New - Schedule',
    onSelect: ({ actions: { setActiveView, navigate } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'create',
        item: 'new_schedule',
      })

      navigate('/schedules/create')

      setActiveView(null)
    },
    isDisabled: ({ orgMember, pathname }) =>
      orgMember?.role !== 'OWNER' || pathname === '/schedules/create/',
    shortcuts: ['c > s'],
  },
  {
    category: 'create',
    label: () => 'Create account',
    icon: () => <ListPlus />,
    value: () => 'Create - New - Account',
    onSelect: ({ actions: { setActiveView, navigate } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'create',
        item: 'new_account',
      })

      navigate('/accounts/create')

      setActiveView(null)
    },
    isDisabled: ({ orgMember, pathname }) =>
      orgMember?.role !== 'OWNER' || pathname.startsWith('/accounts/create'),
    shortcuts: ['c > a'],
  },
  {
    category: 'create',
    label: () => 'Create workspace',
    icon: () => <BadgePlus />,
    value: () => 'Create - New - Workspace',
    onSelect: ({ actions: { setActiveView, setGlobalModalState } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'create',
        item: 'new_team',
      })

      setGlobalModalState({
        isOpen: true,
        content: (
          <NewOrgModal
            isModalOpen
            setIsModalOpen={() => {
              setGlobalModalState({ isOpen: false, content: null })
            }}
          />
        ),
      })
      setActiveView(null)
    },
    shortcuts: ['c > w'],
  },
]
